import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import Widgets from './widgets';
import ReturnPolicySection from '../ReturnPolicy/ReturnPolicySection';

// Import Components
const Default = () => {
  document.title = "Dashboard | Mayave POS";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Widgets />
          </Row>
          <Row>
            <Col xl={12}>
              {/* <StoreDataList /> */}
            </Col>
          </Row>
          {/* <Row>
            <Col xs={12}>
              <ReturnPolicySection />
            </Col>
          </Row> */}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Default;
